import React, {Component} from 'react';
import './ourservices.scss';
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import Reveal from "../../cpr/Reveal";

const SERVICES = [1, 2, 3];

class OurServicesSection extends Component {
    render() {
        const {translate} = this.props;

        return (
            <section className="cpr-section cpr-services" aria-labelledby="cpr-services-title">
                <div className="cpr-container">
                    <h2 id="cpr-services-title" className="cpr-h2 cpr-services__title">{translate('services_title')}</h2>
                    <ul className="cpr-services__list">
                        {SERVICES.map((n, i) => (
                            <Reveal as="li" className="cpr-services__item" key={n} delay={i * 80}>
                                <h3 className="cpr-h3 cpr-sentence">{translate(`services_${n}`)}</h3>
                                <p className="cpr-body">{translate(`services_${n}_info`)}</p>
                            </Reveal>
                        ))}
                    </ul>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(OurServicesSection));
